import React, { Fragment } from "react";
import { Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

export const EmbarqueSumary = (props) => {
  return (
    <Fragment>
      <Card className="myCard">
        <CardBody>
          <div className="row">
            <div className="col-12 row">
              <span
                className="col-8 titleCardResumen"
              >
                <em
                  className={props.headers.logo ? props.headers.logo : ""}
                ></em>
                {props.headers.title}
              </span>
            </div>
            {props.data.map((e, index) => (
              <div key={index} className="col-12">
                <div className="row">
                  <div className="col-12">
                    <span className="mr-3 title-custom-value">
                      {e.label}
                    </span>
                  </div>
                  {e.data.map((ee, index1) => (
                    <div className="col-12" key={index1}>
                      <div className="row">
                        <div className="col-6">
                          <span
                            className={ee.bold ? 'cardTittleResumen' : 'cardNameResumen'}
                            style={{
                              color: "#000",
                              fontWeight: ee.bold ? "bold" : "normal",
                              //fontSize: ee.bold ? "18px" : "12px",
                            }}
                          >
                            {ee.label}{" "}
                          </span>
                          {/* { ee.info ? 
                              <span><Tooltip placement="top" title={ee.tooltip} aria-label="add"><Icon style={{fontSize: '1rem'}}>info</Icon> </Tooltip></span> 
                              : <></>
                              } */}
                        </div>
                        {ee.link ? (
                          <div className="col-6" style={{ textAlign: "right" }}>
                            <Link to={ee.link + ee.value2}>
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "normal",
                                }}
                              >
                                {ee.value}
                              </span>
                            </Link>
                          </div>
                        ) : (
                          <div className="col-6" style={{ textAlign: "right" }}>
                            <span className="tag-custom-value"
                            >
                              {ee.value}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  {index !== props.data.length - 1 ? (
                    <div className="col-12">
                      <hr></hr>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};
